import { Component, Input, OnChanges, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { QueryService } from '@app/core/graphql/query/query.service';
import { ApplicationActions } from '@app/core/ngrx/actions';
import { State } from '@app/core/ngrx/reducers';
import { applicationSelectors } from '@app/core/ngrx/selectors';
import { ApplicationService } from '@app/core/services/application/application.service';
import { PaymentService } from '@app/core/services/payment/payment.service';
import { SubjectService } from '@app/core/services/subject/subject.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { select, Store } from '@ngrx/store';
import { canBook, isNil, validCV } from '@shared/utils/index';
import { Observable } from 'rxjs';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-book-now',
    templateUrl: './application-book-now.component.html',
    styleUrls: ['./application-book-now.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ApplicationBookNowComponent implements OnInit {
    @Input() status?: any;
    @Input() showDynamicCopy;

    // currentApplication$ = this.store.select(applicationSelectors.getCurrentApplication);

    // showMeTheMoney = this.paymentService.getShowMeTheMoney();

    booking: any = {
        stepOne: true,
        stepTwo: false,
    };

    $book = this.store.pipe(select(applicationSelectors.getCanBooking));
    $hasBook = this.store.pipe(select(applicationSelectors.hasReqBooking));

    constructor(
        public paymentService: PaymentService,
        private store: Store<State>,
        public sub: SubjectService,
        public toolService: ToolService
    ) {}

    ngOnInit() {/* empty */}
}
